import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInOutAnimation, quickFadeInOutAnimation } from '@app/core/animations';
import { App } from '@app/core/models/app.model';
import { AppState } from '@app/core/states/app.state';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { Select, Store } from '@ngxs/store';
import moment from 'moment';
import { Observable, Subscription, distinctUntilChanged, filter } from 'rxjs';
import { Notification } from '../../models/notification.model';
import {
  FetchNotificationsRequest,
  OpenNotificationFormFromSidebar,
  ResetPagination,
} from '../../states/notifications.actions';
import { NotificationsState } from '../../states/notifications.state';

@Component({
  selector: 'rk-notification-sidebar',
  templateUrl: './notification-sidebar.component.html',
  styleUrls: ['./notification-sidebar.component.scss'],
  animations: [fadeInOutAnimation, quickFadeInOutAnimation],
  standalone: false,
})
export class NotificationSidebarComponent implements OnInit, OnDestroy {
  @HostListener('scroll', ['$event'])
  @Select(NotificationsState.notifications)
  notifications$: Observable<Notification[]>;

  @Select(NotificationsState.isLoading)
  isLoading$: Observable<boolean>;

  @Select(AppState.currentApp)
  currentApp$: Observable<App>;

  private readonly dataSubscription = new Subscription();

  hideAfterContent = false;

  constructor(
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new ResetPagination());

    this.dataSubscription.add(
      this.currentApp$
        .pipe(
          filter(app => !!app?.appId && app.androidNotificationIsAvailable),
          distinctUntilChanged(),
        )
        .subscribe(() => {
          this.store.dispatch(new FetchNotificationsRequest(1));
        }),
    );
  }

  getTotalSent(notification: Notification): number {
    return notification.processes.reduce((total, process) => total + process.nbSent, 0);
  }

  openForm(event: string) {
    this.store.dispatch(
      new SetEventProperties({
        name: event,
        component: 'Button',
      }),
    );
    this.store.dispatch(new LogEvent('Button Clicked'));
    this.store.dispatch(new OpenNotificationFormFromSidebar());
    setTimeout(() => {
      this.router.navigateByUrl('/notifications');
    }, 200);
  }

  formatDate(date: Date): string {
    return moment(date).format('DD/MM/YY - HH:mm');
  }

  onScroll(event: any) {
    const maxScroll = event.target.scrollHeight - event.target.offsetHeight;
    if (event.target.scrollTop >= maxScroll - 100) {
      this.hideAfterContent = true;
    } else {
      this.hideAfterContent = false;
    }
  }

  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }
}
